import axios from 'axios';
import { clearUserAuthCookies } from './authCookies';

let isRedirecting = false;

const redirectToLogin = () => {
  if (isRedirecting) return;
  isRedirecting = true;
  clearUserAuthCookies();
  window.location.replace('/');
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      redirectToLogin();
      // Return a never-resolving promise so no downstream .catch runs
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);
